import TimelineActivity from '~/components/drawers/timeline/activity';

class TimelineActivityResume extends TimelineActivity {
}

TimelineActivityResume.defaultProps = {
  title:          (obj) => `${obj.props.resume_status} - ${obj.props.activity.parameters.document_title}`,
  color:          'text-deluge',
  icon:           'file',
  prefix:         'far',
  alwaysPublic:   true,
};

export default TimelineActivityResume;
